// hooks/useDirectionsService.ts
import { useCallback } from 'react';

export interface RouteLeg {
  distance: { text: string; value: number };
  duration: { text: string; value: number };
  end_address: string;
  start_address: string;
  end_location: google.maps.LatLng;
  start_location: google.maps.LatLng;
  steps: any[];
}

export interface Route {
  legs: RouteLeg[];
  overview_path: google.maps.LatLng[];
  bounds: google.maps.LatLngBounds;
}

export const useDirectionsService = () => {
  const getRoute = useCallback((
    origin: google.maps.LatLngLiteral,
    destination: google.maps.LatLngLiteral,
    waypoints: google.maps.LatLngLiteral[] = []
  ): Promise<Route | null> => {
    return new Promise((resolve) => {
      if (!window.google || !window.google.maps) {
        resolve(null);
        return;
      }

      const directionsService = new google.maps.DirectionsService();

      const waypointsFormatted: google.maps.DirectionsWaypoint[] = waypoints.map(waypoint => ({
        location: waypoint,
        stopover: true
      }));

      directionsService.route(
        {
          origin: origin,
          destination: destination,
          waypoints: waypointsFormatted,
          travelMode: google.maps.TravelMode.DRIVING,
          optimizeWaypoints: true,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK && result) {
            const route = result.routes[0];
            resolve({
              legs: route.legs as RouteLeg[],
              overview_path: route.overview_path,
              bounds: route.bounds!,
            });
          } else {
            console.warn('Directions request failed:', status);
            resolve(null);
          }
        }
      );
    });
  }, []);

  return { getRoute };
};